import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system from '../../system';
import styles from './index.module.css';
const SYSTEM_PROPS = ['flexProps', 'marginProps', 'positioningProps', 'floatProps'];
const Loader = /*#__PURE__*/function () {
  const Loader = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      name,
      size,
      color,
      accessibilityLabel,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const classNames = {
      [styles.svg]: true,
      [styles.small]: size === 'small',
      [styles.medium]: size === 'medium',
      [styles.large]: size === 'large',
      [styles.xLarge]: size === 'xLarge',
      [styles.xxLarge]: size === 'xxLarge'
    };
    return /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "22 22 44 44",
      className: cx(classNames, className),
      style: style,
      ref: ref
    }, rest), accessibilityLabel && /*#__PURE__*/React.createElement("title", null, accessibilityLabel), /*#__PURE__*/React.createElement("circle", {
      cx: "44",
      cy: "44",
      r: "18",
      className: styles.svg__circle
    }));
  });
  Loader.displayName = 'Loader';
  Loader.identifier = Loader.displayName;
  Loader.clonableProps = SYSTEM_PROPS;
  Loader.defaultProps = {
    accessibilityLabel: 'Loading',
    size: 'medium'
  };
  return Loader;
}();
export default Loader;